import axios from 'axios';
import { eventBus } from '@/common/eventBus';

const api = axios.create({
    baseURL: '/api/',
    mode: 'no-cors',
    timeout: 180000,
    crossdomain: true,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

api.interceptors.response.use(response => {
    return response;
}, error => {
    eventBus.$emit('catch-response-error', { errorResponse: error.response });
    return Promise.reject(error);
});

export { api };
